import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";


import img1 from "../assets/TeamBuilding/arranging.png";
import img2 from "../assets/TeamBuilding/HumanWheel.jpg";
import img3 from "../assets/TeamBuilding/RUGANDBALL.webp";
import img4 from "../assets/TeamBuilding/SMS.png";
import img5 from "../assets/TeamBuilding/treasurehunt.png";
import img6 from "../assets/TeamBuilding/MYSTERIOUSCASE.webp";
import img7 from "../assets/TeamBuilding/CROSSWORD.png";
import img8 from "../assets/TeamBuilding/CUPandHOOPrace.png";
import img9 from "../assets/TeamBuilding/MapGame.webp";
import img10 from "../assets/TeamBuilding/TheCage.png";
import img11 from "../assets/TeamBuilding/Knot.webp";
import img12 from "../assets/TeamBuilding/WALKINGBOARDS.webp";
import img13 from "../assets/TeamBuilding/Buildingthetower.png";
import img14 from "../assets/TeamBuilding/CROSSTHERIVER.webp";
import img15 from "../assets/TeamBuilding/filthewell.jpg";
import img16 from "../assets/TeamBuilding/thePuzzle.jpg";
import img17 from "../assets/TeamBuilding/TugOfWar.webp";
import img18 from "../assets/TeamBuilding/TeamMaze.png";
import img19 from "../assets/TeamBuilding/nailspuzzile.webp";
import img20 from "../assets/TeamBuilding/SquaresGame.webp";
import img21 from "../assets/TeamBuilding/GoldMine.webp";
import img22 from "../assets/TeamBuilding/tangrampuzzle.jpeg";
import img23 from "../assets/TeamBuilding/CubeStacking.jpg";
import img24 from "../assets/TeamBuilding/BestBuilder.webp";
import img25 from "../assets/TeamBuilding/StickyTarget.jpg";
import img26 from "../assets/TeamBuilding/RopeBallDrop.jpg";



const cards = [
  { title: "Arranging the Numbers", description: "Challenge your group to shuffle the numbers they are holding as fast and as accurately as they can to match each number you announce over several rounds.", image: img1 },
  { title: "Human Wheel", description: "The team enters the wheel and moves from one point to another point.", image: img2 },
  { title: "Rug and Balls", description: "Involves the team attempting to drop the colored balls into the corresponding holes.", image: img3 },
  { title: "SMS Competition", description: "A group of puzzles and the answer is sent to the fastest team to solve it.", image: img4 },
  { title: "Treasure Hunt", description: "Solving various riddles in order to reach the treasure.", image: img5 },
  { title: "Mysterious Case", description: "Investigate a realistic case file. Feel like a detective in your own crime story.", image: img6 },
  { title: "Cross Word", description: "Solving a word search.", image: img7 },
  { title: "Cup and Hoop Race", description: "Stacking cones from left and right to the center.", image: img8 },
  { title: "Map Game", description: "Complete a map in 7 steps. A mistake sends you back to start.", image: img9 },
  { title: "The Cage", description: "Use 8 sticks to remove a ball trapped inside a cage.", image: img10 },
  { title: "Untie the Knot", description: "Two players untie a rope puzzle using teamwork.", image: img11 },
  { title: "Walking Boards", description: "Move using boards as a team. Coordination is key.", image: img12 },
  { title: "Building the Tower", description: "Stack cartons to build the tallest tower.", image: img13 },
  { title: "Cross the River", description: "Teams must cross using limited planks. Strategy wins.", image: img14 },
  { title: "Fill the Well", description: "Fill a leaky pipe to float a ball to the top.", image: img15 },
  { title: "The Puzzle", description: "Arrange puzzle pieces to match the sample.", image: img16 },
  { title: "TUG OF WAR", description: "Classic team strength challenge using a rope.", image: img17 },
  { title: "TEAM MAZE", description: "Navigate a hidden path together. Memory matters.", image: img18 },
  { title: "NAILS PUZZLE", description: "Balance 17 nails on 1 nail without touching the base.", image: img19 },
  { title: "5 SQUARES GAME", description: "Form 5 equal squares from given pieces.", image: img20 },
  { title: "GOLD MINE", description: "Guide a blindfolded teammate to collect coins safely.", image: img21 },
  { title: "TANAGRAM PUZZLE", description: "Make shapes using 7 colored blocks.", image: img22 },
  { title: "CUBE STACKING", description: "Stack cubes using ropes — one rope per player.", image: img23 },
  { title: "BEST BUILDER", description: "Replicate a structure exactly as shown.", image: img24 },
  { title: "Rope Ball Drop", description: "A team-based activity involving four players collaboratively maneuvering a ball using eight ropes, with the objective of accurately placing it into a designated bucket.", image: img26 },
  { title: "Sticky Target", description: "A game where participants aim to throw balls onto the back of a player’s jacket. If all the balls successfully stick, the targeted player is considered out.", image: img25 },
];

// Main component
export default function TeamBuildingComponents() {
  return (
    <div className="mt-44 flex min-h-screen flex-col items-center justify-center px-6 py-12">
      
      {/* Title */}
      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true }}
        className="text-5xl  font-bebas text-black mb-12 text-center uppercase"
      >
        Team Building Games
      </motion.h2>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {cards.map((card, index) => (
          <AnimatedCard key={index} card={card} />
        ))}
      </div>
    </div>
  );
}

// Card component
function AnimatedCard({ card }) {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.15 });

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    } else {
      controls.start({ opacity: 0, y: 40 });
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={controls}
      transition={{ duration: 0.6, ease: "easeInOut" }}
      whileHover={{
        scale: 1.05,
        rotateZ: 1,
        transition: { type: "spring", stiffness: 300, damping: 20 },
      }}
      className="group relative cursor-pointer overflow-hidden rounded-xl shadow-lg transition-transform duration-500"
    >
      {/* Image */}
      <img
        src={card.image}
        alt={card.title}
        className="h-96 w-72 object-cover transition-transform duration-700 group-hover:scale-110"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/80 opacity-80 group-hover:backdrop-blur-sm transition-all duration-500" />

      {/* Text */}
      <div className="absolute inset-0 flex flex-col items-center justify-end p-6 text-white transition-all duration-500 
        [@media(any-hover:hover)]:translate-y-1/2 [@media(any-hover:hover)]:opacity-0 
        [@media(any-hover:hover)]:group-hover:translate-y-0 
        [@media(any-hover:hover)]:group-hover:opacity-100"
      >
        <h1 className="text-2xl font-bold text-center">{card.title}</h1>
        <p className="mt-2 mb-4 text-sm italic text-center">{card.description}</p>
        
      </div>
    </motion.div>
  );
}
